export const getIds = (data, key = 'value') => {
  return data
    .map((item) => item[key])
    .map((item) => `'${item}'`)
    .join(",")
}

export const getLabels = (data) => {
  return data
    .map((item) => item.label)
    .map((item) => `'${item}'`)
    .join(",")
}
